export var MealType;
(function (MealType) {
    MealType["MAIN"] = "main";
    MealType["ADDITIONAL"] = "additional";
})(MealType || (MealType = {}));
